/* ==========================================================================
   Nerdy Creations — Motion JS
   Loaded via layout/theme.liquid with defer before </body>
   ========================================================================== */

/* --------------------------------------------------------------------------
   1. HERO TEXT ENTER — fires on DOMContentLoaded, no IntersectionObserver
   -------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  var heroEls = document.querySelectorAll('.nc-hero-text-enter');
  if (heroEls.length === 0) return;

  // Double rAF: ensures one paint cycle separates initial opacity:0 from
  // the class add, so the CSS transition has a state to transition from.
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      heroEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
    });
  });
});

/* --------------------------------------------------------------------------
   2. SECTION REVEAL ON SCROLL — IntersectionObserver, never scroll event
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  // Fallback: if IntersectionObserver not supported, reveal everything immediately
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.nc-reveal, .nc-reveal-stagger').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var revealObserver = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // fire once only — never re-hides
        }
      });
    },
    {
      // Trigger when element has scrolled 80px past the fold.
      // Prevents elements near the fold from firing too early on load.
      rootMargin: '-80px 0px',
      threshold: 0
    }
  );

  document.querySelectorAll('.nc-reveal, .nc-reveal-stagger').forEach(function (el) {
    revealObserver.observe(el);
  });
})();
